/*
    多页签更多按钮高阶组件
    created by: liyaoh 2020-07-28
*/
import React from 'react';
import { findDOMNode } from 'react-dom';
import platform from 'Pub/js/platform';
import { setActiveTabKey, TAB_FLAG } from '../../events';
const { NCDropdown, NCMenu } = platform.base;
const { Item } = NCMenu;
//type： 多页签区域类型 form：主表 table：子表
export default function withTabMoreArea (type) {
    return function(WrapperComponent) {
        return class TabMoreArea extends React.Component {
            state = {
                showTabsMoreBtn: false, //是否显示多页签更多按钮
            };

            componentDidMount() {
                this.checkShowTabsMoreBtn(); //检查是否显示多页签更多按钮
            }

            componentWillReceiveProps(nextProps) {
                this.checkShowTabsMoreBtn(); //检查是否显示多页签更多按钮
            }

            //得到全部页签数据
            getAllTabs = () => {
                const { areaItem } = this.props;
                const tabArea = areaItem[[TAB_FLAG[type]]];
                if(tabArea) {
                    return [areaItem].concat(tabArea);
                } else {
                    return [areaItem];
                }
            };

            //更多页签下拉菜单
            getMoreMenu = () => {
                const allTabs = this.getAllTabs();
                const onSelect = ({ key }) => {
                    const selectedArea = allTabs.find(item => item.code === key) || {};
                    setActiveTabKey({
                        activeKey: key,
                        areaCode: this.props.areaItem.code,
                    });
                    this.props.updateSelectArea(selectedArea);
                };
                return (
                    <NCMenu className="mutitabs-menu" onSelect={onSelect}>
                        {allTabs.map(item => (
                            <Item key={item.code}>{item.name}</Item>
                        ))}
                    </NCMenu>
                );
            };

            //判断多页签是否显示更多按钮
            checkShowTabsMoreBtn = () => {
                //异步目的是等左右箭头渲染出来
                setTimeout(() => {
                    const $area = findDOMNode(this.component);
                    //找到多页签左右箭头就表示显示更多按钮
                    let showTabsMoreBtn = $area && $area.querySelector('.wui-tabs-tab-next.wui-tabs-tab-arrow-show') ? true : false;
                    this.setState({ showTabsMoreBtn });
                }, 0);
            };

            //渲染页签右侧内容
            renderTabsExtraArea = () => {
                const style = !this.state.showTabsMoreBtn ? { display: 'none' } : {};
                return (
                        <NCDropdown
                            trigger={['click']}
                            overlay={this.getMoreMenu()}
                            animation="slide-up"
                            placement="topLeft"
                            overlayClassName="multabs-menu-list"
                        >
                            <div className="tab-opr-more" style={style}>
                                <i className="iconfont icon-gengduomoban" />
                            </div>
                        </NCDropdown>
                );
            };

            render() {
                const newProps = {
                    tabsExtraArea: this.renderTabsExtraArea(),
                    ...this.props
                }
                return <WrapperComponent ref={ref => this.component = ref} {...newProps}/>
            }
        }
    }
};
